import { ERegion, EVerticalNames } from '@constants';
import { IUserInfo } from '@sdk/contracts';
import { Form, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';

import { AutonomousCommunitySelector } from '@/components/Form';
import { ExamGroupSelector } from '@/components/Form/ExamGroupSelector';
import { useProfile } from '@/store';

type RegionSpecificFieldsProps = {
  form: FormInstance<IUserInfo>;
  userInfo?: IUserInfo;
};

export const RegionSpecificFields: React.FC<RegionSpecificFieldsProps> = ({ form, userInfo }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const { profile } = useProfile();
  const region = profile?.regionConfig ?? ERegion.ES;

  switch (region) {
    case ERegion.PT:
      return null;
    case ERegion.ES:
    default:
      return (
        <>
          <Form.Item
            name={['uniUserInfo', 'autonomousCommunity']}
            label={t('AUTONOMOUS_COMMUNITY')}
            rules={[{ required: true, message: t('AUTONOMOUS_COMMUNITY') }]}>
            <AutonomousCommunitySelector
              onChange={value =>
                form.setFieldsValue({
                  uniUserInfo: { ...form.getFieldValue('uniUserInfo'), autonomousCommunity: value }
                })
              }
            />
          </Form.Item>

          <Form.Item
            name={['examGroups']}
            label={t('StudentProfileConfigurationTranslations:EXAM_GROUPS')}
            initialValue={userInfo?.examGroups}>
            <ExamGroupSelector
              vertical={EVerticalNames.UNI}
              onChange={(value: string[] | string) =>
                form.setFieldsValue({ examGroups: Array.isArray(value) ? value : [value] })
              }
              value={userInfo?.examGroups}
            />
          </Form.Item>
        </>
      );
  }
};
